export enum DocumentPreviewType {
	modal = "modal",
	newTab = "newTab",
}